export default __webpack_public_path__ + "static/media/tools-bj-top.468c878c.png";